var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container-fluid"},[_c('b-row',[_c('b-col',{attrs:{"lg":"12"}},[_c('p',[_vm._v(_vm._s(_vm.stripeLog))])])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }